import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { FUSE_SKIP_LOADING } from '@fuse/services/loading/loading-context.token';
import { LoadingStateService } from '../services/loading-state.service';

export const loadingInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const _loadingStateService = inject(LoadingStateService);

  if (req.context.get(FUSE_SKIP_LOADING)) {
    return next(req);
  }

  _loadingStateService.start();

  return next(req).pipe(finalize(() => _loadingStateService.stop()));
};
